import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-redirect-icon-cwm",
  "use": "icon-redirect-icon-cwm-usage",
  "viewBox": "0 0 14.559 14.559",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.559 14.559\" id=\"icon-redirect-icon-cwm\">\n  <path id=\"icon-redirect-icon-cwm_np_external_1355974_000000\" d=\"M14.56.125c0-.029,0-.029-.029-.058,0-.029,0-.029-.029-.058,0-.029-.029-.029-.029-.058s-.029-.029-.029-.058a.5.5,0,0,0-.175-.175L14.24-.31c-.029,0-.029-.029-.058-.029s-.029,0-.058-.029c-.029,0-.029,0-.058-.029h-5.3a.584.584,0,0,0-.582.582.584.584,0,0,0,.582.582H12.58L11.415,1.931H.583A.584.584,0,0,0,0,2.513V13.579a.584.584,0,0,0,.582.582H11.648a.584.584,0,0,0,.582-.582V2.8L13.4,1.64V5.454a.582.582,0,1,0,1.165,0V.125ZM11.066,13.054h-9.9v-9.9H10.25L5.708,7.7a.563.563,0,0,0,0,.816.563.563,0,0,0,.816,0l4.542-4.542Z\" transform=\"translate(-0.001 0.398)\" fill=\"#005999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/redirect-icon-cwm.svg
// module id = 169
// module chunks = 0 1 2